/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import theme from '../../theme'
import 'react-multi-carousel/lib/styles.css'
import slugify from 'slugify'
import Slider from 'react-slick'
import THUMBNAIL_PADRAO from '@monorepo-amais/commons/images/thumbnail_padrao.png'

import { CircularProgress, Container, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { BreadcrumbAuto } from '../Blocks'
import { MainTitle, SubTitle, SubTitleCustom } from '@monorepo-amais/commons/components/Typography'
import imgixUrlOptimizerAuto from '../../utils/imgixUrlOptimizerAuto'

import download from 'downloadjs'

import * as S from './styles'
import SvgDownload from '../Icons/Download'
import SvgShare from '../Icons/Share'
import arrowLeft from '../../Icons/arrow-left.svg'
import arrowRight from '../../Icons/arrow-right.svg'
import { getInstructionsByExams } from '../../repositories/examsInstructions'

const UnitiesMobileBg = styled.div`
	//background: ${theme.colors.grayf8};
	background: #FFF;
	font-family: 'InclusiveSans' !important;		
	padding: 40px 0 0px 15px;
	margin: 10px 0 40px 0;
	
	@media (min-width: 1024px) {
		background: none;
		padding: 0;
		margin: 0;
	}
`

const UnidadeLink = styled(Link)`
	font-family: 'InclusiveSans' !important;
	text-decoration: none;
	color: #00729e;
	font-size: 14px;
`

const UnidadeMapa = styled.button`
	//font-family: 'InclusiveSans' !important;
	font-family: 'InclusiveSans' !important;
	text-decoration: none;
	background: none;
	border: none;
	color: #00729e;
	font-size: 14px;
	cursor: pointer;
`

const UnidadesButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin: -16px 8px 30px;
`

const UnidadesButton = styled(Link)`
	//font-family: 'InclusiveSans' !important;
	font-family: 'InclusiveSans' !important;
	text-decoration: none;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	border-radius: 100px;
	width: 200px;
	height: 48px;
	border: none;
	background-color: white;
	color: #009edb;
	border: 2px solid #009edb;

	&:not([disabled]):hover {
		background: #f1f1f1;
		cursor: pointer;
	}
`

const Button = styled.button`
	font-family: 'InclusiveSans' !important;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	font-weight: 600;
	border-radius: 100px;
	width: 100%;
	height: 48px;
	border: none;
	background-color: #009edb;
	color: white;
	padding: 0.5rem 1rem;
	margin: 0px 0px 30px;

	white-space: pre-wrap;

	svg {
		color: white;
	}

	&:not([disabled]):hover {
		background: #2eb0e4;
		border-color: #2eb0e4;
		cursor: pointer;
	}

	&:not([disabled]):active {
		background: ${theme.colors.primary};
		border-color: ${theme.colors.primary};
	}

	&:disabled {
		background-color: #e0e0e0;
	}
`

const PrintContainer = styled.div`
	font-family: 'InclusiveSans' !important;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 24px;
	padding: 16px 160px;
	@media (max-width: 1024px) {
		padding: 16px 40px;
	}
`

const InfoText = styled.div`
	margin-left: 2px;
	font-family: 'InclusiveSans' !important;
	font-size: 16px !important;
`

const Unities = styled.div`
	font-family: 'InclusiveSans' !important;
	width: 90%;
	margin: 0 auto;
	@media (max-width: 1023.98px) {
		width: unset;
		margin-bottom: 10px;
	}
	@media (max-width: 1024px) {
		margin-bottom: 10px;
	}

	.slick-track {
		display: flex;
		margin: inherit;
	}
	.slick-dots {
		bottom: -20px;
		li {
			width: 11px;
			height: 11px;
			button {
				width: 11px;
				height: 11px;
				&:before {
					width: 11px;
					height: 11px;
					line-height: 11px;
					font-size: 9.4px;
					color: ${theme.colors.graye4};
					opacity: 1;
				}
			}
			&.slick-active {
				button {
					&:before {
						color: ${theme.colors.primary};
					}
				}
			}
		}
	}

	.slick-slide {
		margin: 0 10px 0 0;
	}
	.unity {
		height: 328px;
		min-width: 230px;
		max-width: 231px;
		margin: 0px;
		background: #ffffff;
		//box-shadow: 4px 5px 5px -3px rgba(0, 0, 0, 0.1);
		box-shadow: 1px 0px 8px 3px rgba(117, 117, 117, 0.15);
		border: 1px solid ${theme.colors.graye4};
		border-radius: 24px;
		margin-bottom: 16px;

		@media (max-width: 1024px) {
			min-width: 191px;
			max-width: 192px;
		}

		@media (max-width: 500px) {
			min-width: 191px;
			max-width: 192px;
		}
	}

	.unity-address {
		height: 288px;
	}

	.bottom-links {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 8px;
		color: ${theme.colors.primary} !important;
	}

	img {
		-webkit-border-radius: 5px;
		-moz-border-radius: 5px;
		border-radius: 5px;
		width: 100%;
		max-height: 120px;
		@media (max-width: 1024px) {
			max-height: 110px;
		}
	}
	.name {
		font-family: 'InclusiveSans' !important;
		font-size: 16px;
		font-weight: 900;
		color: ${theme.colors.black33};
		margin: 10px 0;
		padding: 0 6px;
	}
	.address {
		font-family: 'InclusiveSans' !important;
		font-size: 14px;
		line-height: 20px;
		color: ${theme.colors.gray66};
		padding: 0 6px;
	}
	.slick-next {
		right: -30px;
		@media (max-width: 1023.98px) {
			display: none !important;
		}
	}
	.slick-prev {
		@media (max-width: 1023.98px) {
			display: none !important;
		}
	}
	.slick-next:before {
		display: none;
	}
	.slick-prev:before {
		display: none;
	}
	.slick-next.slick-disabled {
		opacity: 0;
	}
	.slick-prev.slick-disabled {
		opacity: 0;
	}
`

const ExameDetalhe = props => {
	const { infoEstat, idLegado, nome, instrucoesGerais, sinonimias, unidades, precisaAgendar, Layout } = props
	const themeMui = useTheme()
	const upOfSm = useMediaQuery(themeMui.breakpoints.up('sm'))
	const [canShare, setCanShare] = useState(false)
	const [loading, setLoading] = useState(false)
	const [arrayUnidades, setArrayUnidades] = useState([])
	const [currentPath, setCurrentPath] = useState('')

	const ICONETELEFONE = `<svg className='icone-contato' width="18" height="17" viewBox="0 0 19 18" fill="${theme.colors.primary}" xmlns="http://www.w3.org/2000/svg"><path d="M12.1923 12.7925L13.7211 11.2419C13.927 11.0356 14.1875 10.8944 14.471 10.8355C14.7545 10.7765 15.0487 10.8022 15.3181 10.9096L17.1812 11.6641C17.4534 11.7762 17.6868 11.9675 17.8519 12.2138C18.0171 12.4602 18.1067 12.7507 18.1094 13.0486V16.5098C18.1078 16.7124 18.0658 16.9127 17.9859 17.0985C17.906 17.2842 17.7899 17.4517 17.6445 17.5907C17.4991 17.7298 17.3275 17.8376 17.14 17.9076C16.9525 17.9776 16.7529 18.0083 16.5533 17.9981C3.4976 17.1743 0.863252 5.96015 0.365046 1.66831C0.341919 1.45755 0.363049 1.24421 0.427047 1.04233C0.491046 0.840448 0.596461 0.654598 0.736358 0.497007C0.876255 0.339416 1.04746 0.213655 1.23872 0.127997C1.42998 0.0423395 1.63695 -0.00127313 1.84602 2.82909e-05H5.14237C5.43652 0.000911431 5.72369 0.0910343 5.96693 0.258805C6.21017 0.426576 6.39837 0.664322 6.50732 0.941464L7.25121 2.83126C7.36058 3.10335 7.38849 3.4021 7.33144 3.69019C7.27439 3.97827 7.13492 4.24292 6.93045 4.45108L5.40171 6.00168C5.40171 6.00168 6.2821 12.0449 12.1923 12.7925Z"/></svg>`
	const ICONEWHATSAPP = `<svg className='icone-contato' width="18" height="18" viewBox="0 0 22 22" fill="${theme.colors.primary}" xmlns="http://www.w3.org/2000/svg"><path d="M16.0165 13.1835C15.7433 13.0469 14.404 12.3888 14.1547 12.2971C13.9054 12.2064 13.7239 12.1614 13.5415 12.4346C13.36 12.7059 12.8384 13.3201 12.6798 13.5016C12.5203 13.684 12.3617 13.706 12.0895 13.5703C11.8172 13.4328 10.939 13.1459 9.89863 12.2183C9.08922 11.4959 8.54197 10.604 8.38339 10.3309C8.2248 10.0586 8.36597 9.91102 8.50255 9.77535C8.62539 9.65344 8.7748 9.45727 8.91139 9.29869C9.04797 9.13919 9.09289 9.02552 9.18364 8.84311C9.2753 8.66161 9.22947 8.50302 9.16072 8.36644C9.09289 8.22986 8.54839 6.88878 8.32105 6.34336C8.10014 5.81261 7.87556 5.88503 7.70872 5.87586C7.54922 5.86853 7.36772 5.86669 7.18622 5.86669C7.00472 5.86669 6.70956 5.93453 6.46022 6.20769C6.20997 6.47994 5.50689 7.13903 5.50689 8.48011C5.50689 9.82027 6.48222 11.1155 6.61881 11.2979C6.75539 11.4794 8.53922 14.2313 11.2718 15.411C11.9226 15.6915 12.4295 15.8593 12.8246 15.9839C13.4773 16.192 14.0713 16.1627 14.5406 16.0921C15.0631 16.0142 16.1521 15.433 16.3795 14.7968C16.6059 14.1607 16.6059 13.6153 16.538 13.5016C16.4702 13.3879 16.2887 13.3201 16.0155 13.1835H16.0165ZM11.0463 19.9696H11.0426C9.41961 19.9699 7.8264 19.5336 6.42997 18.7064L6.09997 18.5103L2.66981 19.4104L3.58556 16.0664L3.37015 15.7236C2.46277 14.2792 1.98258 12.6076 1.98506 10.9019C1.9869 5.90611 6.05139 1.84162 11.05 1.84162C13.47 1.84162 15.7451 2.78578 17.4556 4.49811C18.2993 5.33831 18.968 6.33746 19.423 7.43776C19.8781 8.53807 20.1104 9.71768 20.1066 10.9084C20.1048 15.9042 16.0403 19.9696 11.0463 19.9696ZM18.7573 3.19737C17.7473 2.18071 16.5456 1.37461 15.2218 0.82577C13.898 0.276929 12.4784 -0.00373655 11.0454 3.75627e-05C5.03756 3.75627e-05 0.146234 4.89045 0.144401 10.901C0.141617 12.8139 0.64341 14.6936 1.59915 16.3506L0.0527344 22L5.83139 20.4838C7.42994 21.3548 9.2213 21.8111 11.0417 21.8112H11.0463C17.0541 21.8112 21.9454 16.9208 21.9473 10.9093C21.9517 9.47677 21.6721 8.05762 21.1245 6.73389C20.577 5.41016 19.7724 4.20815 18.7573 3.19737Z"/></svg>`

	const examsToScheduleFromExternalLink = [
		'/sp/exames/espermatozoides-anticorpos-soro/',
		'/sp/exames/entamoeba-histolytica-anticorpos-soro/'
	]
	const labsAmaisSitesThatNeedToBeScheduleFromHome = ['amaissp', 'amaispr', 'amaispe', 'amaispi', 'labs-amais']
	const examsCardsThatWontBeModified = ['Convênios', 'Convênio e cobertura', 'Particular e valores']
	// * * * * * * * * * * * * * * * * * * * * * * *
	// Esta é uma correção temporário para o procedimento "Perfuração do lóbulo, Auricular" em a+ SP
	// Após correção das informações no backend, a condição deverá ser retirada
	const precisaSerAgendado = process.env.COSMIC_BUCKET === 'amaissp' && idLegado === 9327 ? true : precisaAgendar
	// * * * * * * * * * * * * * * * * * * * * * * *

	const printInstructions = async examId => {
		setLoading(true)
		const exams = await getInstructionsByExams(examId)

		const pdf = new File([exams], 'instrucoes.pdf', { type: 'application/pdf' })
		const files = [pdf]

		if (!canShare) {
			download(exams, 'instrucoes.pdf', 'application/pdf')
			setLoading(false)
		} else {
			setLoading(false)
			await navigator?.share({
				title: 'Instruções de preparo',
				files
			})
		}
	}

	// Criando um array de unidades para ser mostrado no react-slick
	// TODO: Layout está zuado
	// const arrayUnidades = useMemo(
	// 	() =>
	// 		(unidades || []).map(unit => (
	// 			<div className='unity' key={`exams-unities-${unit.slug}`}>
	// 				<div className='unity-address'>
	// 					{unit.thumbnail && unit.thumbnail.imagem.imgix_url && (
	// 						<img src={imgixUrlOptimizerAuto(unit.thumbnail.imagem.imgix_url, 312, 204)} alt='Unidade' />
	// 					)}
	// 					{(!unit.thumbnail || !unit.thumbnail.imagem.imgix_url) && <img src={THUMBNAIL_PADRAO} alt='Unidade' />}
	// 					<p className='name'>{unit.nome}</p>
	// 					<p className='address'>
	// 						{unit.endereco} - {unit.bairro} - {unit.estado} - {unit.cep}
	// 					</p>
	// 				</div>
	// 				<div className='bottom-links'>
	// 					<UnidadeMapa
	// 						onClick={() => {
	// 							window.open(
	// 								`https://maps.google.com/maps?q=${encodeURIComponent(
	// 									unit.nome + unit.endereco + unit.bairro + unit.cidade
	// 								)}+(${encodeURIComponent(unit.nome)})&ie=UTF8`
	// 							)
	// 						}}
	// 					>
	// 						Ver no mapa
	// 					</UnidadeMapa>
	// 					<UnidadeLink id={`exam-unit-${unit.nome}`} to={'/unidades/' + slugify(unit.nome).toLowerCase()}>
	// 						Abrir detalhes
	// 					</UnidadeLink>
	// 				</div>
	// 			</div>
	// 		)),
	// 	[unidades]
	// )

	function SampleNextArrow(props) {
		const { className, style, onClick } = props
		return (
			<button
				className={className}
				style={{
					...style,
					display: 'block',
					backgroundImage: `url(${arrowRight})`,
					backgroundSize: 'contain',
					backgroundRepeat: 'no-repeat'
				}}
				onClick={onClick}
			/>
		)
	}

	function SamplePrevArrow(props) {
		const { className, style, onClick } = props
		return (
			<button
				className={className}
				style={{
					...style,
					display: 'block',
					backgroundImage: `url(${arrowLeft})`,
					backgroundSize: 'contain',
					backgroundRepeat: 'no-repeat'
				}}
				onClick={onClick}
			/>
		)
	}

	const slickSettings = {
		infinite: false,
		// slidesToShow: 3,
		arrows: true,
		variableWidth: true,
		nextArrow: <SampleNextArrow />,
		prevArrow: <SamplePrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					// slidesToShow: 3,
					variableWidth: true,
					slidesToScroll: 1,
					centerMode: false,
					infinite: true,
					centerPadding: 50,
					dots: false //see: https://github.com/kenwheeler/slick/issues/2130
				}
			},
			{
				breakpoint: 768,
				settings: {
					// slidesToShow: 3,
					variableWidth: true,
					slidesToScroll: 1,
					centerMode: false,
					infinite: true,
					centerPadding: 50,
					dots: false
				}
			}
		]
	}

	useEffect(() => {
		const shareInstuctions = window.navigator
		const IS_IPAD = navigator.userAgent.match(/iPad/i) != null,
			IS_IPHONE =
				!IS_IPAD && (navigator.userAgent.match(/iPhone/i) != null || navigator.userAgent.match(/iPod/i) != null),
			IS_IOS = IS_IPAD || IS_IPHONE,
			IS_ANDROID = !IS_IOS && navigator.userAgent.match(/android/i) != null,
			IS_MOBILE = IS_IOS || IS_ANDROID

		if (IS_MOBILE) {
			if (typeof shareInstuctions?.canShare !== 'undefined') {
				if (!shareInstuctions?.canShare) {
					setCanShare(false)
				} else {
					setCanShare(true)
				}
			}
		} else {
			setCanShare(false)
		}
	}, [])

	useEffect(() => {
		if (loading) {
			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({
				event: 'exams_instructions_download',
				formLocation: 'exames'
			})
		}
	}, [loading])

	useEffect(() => {
		if (unidades.length > 0) {
			setArrayUnidades(
				unidades.map(unit => (
					<div className='unity' key={`exams-unities-${unit.slug}`}>
						<div className='unity-address'>
							{unit.thumbnail && unit.thumbnail.imagem.imgix_url && (
								<img src={imgixUrlOptimizerAuto(unit.thumbnail.imagem.imgix_url, 312, 204)} alt='Unidade' />
							)}
							{(!unit.thumbnail || !unit.thumbnail.imagem.imgix_url) && <img src={THUMBNAIL_PADRAO} alt='Unidade' />}
							<p className='name'>{unit.nome}</p>
							<p className='address'>
								{unit.endereco} - {unit.bairro} - {unit.estado} - {unit.cep}
							</p>
						</div>
						<div className='bottom-links'>
							<UnidadeMapa
								onClick={() => {
									window.open(
										`https://maps.google.com/maps?q=${encodeURIComponent(
											unit.endereco + ' ' + unit.bairro + ' ' + unit.cidade + ' ' + unit.nome
										)}+(${encodeURIComponent(unit.nome)})&ie=UTF8`
									)
								}}
							>
								Ver no mapa
							</UnidadeMapa>
							<UnidadeLink id={`exam-unit-${unit.nome}`} to={'/unidades/' + slugify(unit.nome).toLowerCase()}>
								Abrir detalhes
							</UnidadeLink>
						</div>
					</div>
				))
			)
		} else {
			setArrayUnidades([])
		}
	}, [unidades])

	useEffect(() => {
		if (typeof window !== 'undefined') {
			setCurrentPath(window.location.pathname)
			console.log('Este aqui é o pathname: ' + window.location.pathname)
		}
	}, [])

	return (
		<Layout>
			<Container>
				<S.ExamWrapper>
					{upOfSm && <BreadcrumbAuto title={nome} />}
					<Grid container alignItems='flex-start' justifyContent='space-between' spacing={4}>
						<Grid item xs={12} sm={12} lg={12}>
							<SubTitleCustom>Preparos do exame</SubTitleCustom>
						</Grid>
						<Grid item xs={12} sm={12} lg={6}>
							<S.InstructionsContainer>
								<S.PaddingContainer>
									<MainTitle>{nome}</MainTitle>
									<S.Spacing />
									<Typography style={{ fontFamily: 'InclusiveSans' }} color='textPrimary'>
										<b>Outros nomes:</b> {sinonimias && sinonimias.join(', ')}
									</Typography>
								</S.PaddingContainer>

								{precisaSerAgendado ? (
									<S.NeedSchedule className='need'>Este exame precisa ser agendado</S.NeedSchedule>
								) : (
									<S.NeedSchedule>Este exame não precisa ser agendado</S.NeedSchedule>
								)}
								<S.PaddingContainer>
									{instrucoesGerais &&
										instrucoesGerais.map((instruction, key) => {
											//const isDeadline = instruction?.titulo.match(/Prazo de Entrega/)

											const isZero = instruction && instruction?.conteudo === '0'

											const conteudoItem = instruction?.conteudo
												? instruction?.conteudo?.replace(/\n/g, '<br/>')
												: '<br/>'

											return (
												<Grid item xs={12} sm={6} lg={12} key={key}>
													{!isZero && (
														<S.Spacing>
															<SubTitle>
																{instruction?.titulo}
																{/* {isDeadline && '*'} */}
															</SubTitle>
															<S.SpacingMin />
															<InfoText
																style={{ fontFamily: 'InclusiveSans' }}
																dangerouslySetInnerHTML={{
																	__html: conteudoItem
																}}
															/>
														</S.Spacing>
													)}
												</Grid>
											)
										})}

									<PrintContainer>
										<Button variant='contained' color='primary' fullWidth onClick={() => printInstructions(idLegado)}>
											{!canShare ? (
												<>
													<SvgDownload color='#fff' /> <span> &nbsp;&nbsp;&nbsp; Baixar preparo </span>
												</>
											) : (
												<>
													<SvgShare color='#fff' />
													<span> &nbsp;&nbsp;&nbsp; Compartilhar </span>
												</>
											)}

											{loading && (
												<>
													<span> &nbsp;&nbsp;</span>
													<CircularProgress size={16} color='inherit' />
												</>
											)}
										</Button>
									</PrintContainer>
								</S.PaddingContainer>
							</S.InstructionsContainer>
						</Grid>
						<Grid item xs={12} sm={12} lg={6}>
							<Grid container spacing={5}>
								{infoEstat?.metadata?.informacoes_adicionais &&
									infoEstat?.metadata?.informacoes_adicionais.map((info, key) => (
										<>
											{info.titulo_card !== 'Faça em casa' && labsAmaisSitesThatNeedToBeScheduleFromHome.includes(process.env.COSMIC_BUCKET) && (
												<>
													<Grid item xs={12} key={key}>
														<S.InfoContainer>
															<Grid container spacing={3}>
																<Grid item xs={12}>
																	{' '}
																	<SubTitleCustom variant='h2'>{info.titulo_card}</SubTitleCustom>
																</Grid>
																<Grid item xs={12}>
																	<InfoText
																		dangerouslySetInnerHTML={{
																			__html: info.informacoes_card
																				.replace('ICONETELEFONE', ICONETELEFONE)
																				.replace('ICONEWHATSAPP', ICONEWHATSAPP)
																		}}
																	/>
																</Grid>
																{info?.texto_botao_card && (
																	<Grid item xs={12}>
																		<a
																			style={{ textDecoration: 'none' }}
																			target={
																				info?.acao_botao_card.substring(0, 20) === 'https://api.whatsapp' ||
																				info?.acao_botao_card.substring(0, 4) === 'tel:'
																					? '_blank'
																					: ''
																			}
																			href={
																				process.env.COSMIC_BUCKET === 'labs-amais'
																					? 'https://agendamento.labsamais.com.br/'
																					: info?.acao_botao
																			}
																			rel='noopener noreferrer'
																		>
																			<Button
																				variant='contained'
																				color='primary'
																				fullWidth
																				href={info?.acao_botao_card}
																			>
																				Agendar Agora
																			</Button>
																		</a>
																	</Grid>
																)}
															</Grid>
														</S.InfoContainer>
													</Grid>
												</>
											)}
											{!labsAmaisSitesThatNeedToBeScheduleFromHome.includes(process.env.COSMIC_BUCKET) && (
												<>
													<Grid item xs={12} key={key}>
														<S.InfoContainer>
															<Grid container spacing={3}>
																<Grid item xs={12}>
																	{' '}
																	<SubTitleCustom variant='h2'>{info.titulo_card}</SubTitleCustom>
																</Grid>
																<Grid item xs={12}>
																	<InfoText
																		dangerouslySetInnerHTML={{
																			__html: info.informacoes_card
																				.replace('ICONETELEFONE', ICONETELEFONE)
																				.replace('ICONEWHATSAPP', ICONEWHATSAPP)
																		}}
																	/>
																</Grid>
																{info?.texto_botao_card && (
																	<Grid item xs={12}>
																		<a
																			style={{ textDecoration: 'none' }}
																			target={
																				info?.acao_botao_card.substring(0, 20) === 'https://api.whatsapp' ||
																				info?.acao_botao_card.substring(0, 4) === 'tel:'
																					? '_blank'
																					: ''
																			}
																			href={
																				process.env.COSMIC_BUCKET === 'labs-amais'
																					? 'https://agendamento.labsamais.com.br/'
																					: info?.acao_botao
																			}
																			rel='noopener noreferrer'
																		>
																			<Button
																				variant='contained'
																				color='primary'
																				fullWidth
																				href={info?.acao_botao_card}
																			>
																				Agendar Agora
																			</Button>
																		</a>
																	</Grid>
																)}
															</Grid>
														</S.InfoContainer>
													</Grid>
												</>
											)}
										</>
									))}
								{labsAmaisSitesThatNeedToBeScheduleFromHome.includes(process.env.COSMIC_BUCKET) && (
									<Grid item xs={12}>
										<S.InfoContainer>
											<Grid container spacing={3}>
												<Grid item xs={12}>
													{' '}
													<SubTitleCustom variant='h2'>Faça em casa</SubTitleCustom>
												</Grid>
												<Grid item xs={12}>
													<InfoText
														dangerouslySetInnerHTML={{
															__html: `
																		<p>
																			Agora, você pode fazer exames de sangue, urina e fezes em casa, no trabalho ou onde preferir. 
																		</p>
																	`
														}}
													/>
												</Grid>
												<Grid item xs={12}>
													<a
														style={{ textDecoration: 'none' }}
														target={'_blank'}
														href={
															process.env.COSMIC_BUCKET === 'labs-amais' ? 'https://agendamento.labsamais.com.br/' : 'https://agendamento.amaissaude.com.br/'
														}
														rel='noopener noreferrer'
													>
														<Button variant='contained' color='primary' fullWidth>
															Agendar Agora
														</Button>
													</a>
												</Grid>
											</Grid>
										</S.InfoContainer>
									</Grid>
								)}
								{arrayUnidades?.length > 0 && (
									<Grid item xs={12}>
										<Grid container spacing={3}>
											<Grid item xs={12}>
												{' '}
												<SubTitleCustom variant='h2'>
													{`${unidades?.length} 
													${unidades?.length > 1 ? 'unidades oferecem ' : 'unidade oferece '}
														esse exame`}
												</SubTitleCustom>
											</Grid>
											<Grid item xs={12}>
												<UnitiesMobileBg>
													<Unities>
														{/* {arrayUnidades.length >= 4 ? (
															<Slider {...slickSettings}>{arrayUnidades}</Slider>
														) : (
															{ arrayUnidades }
														)} */}
														<Slider {...slickSettings}>{arrayUnidades}</Slider>
													</Unities>
												</UnitiesMobileBg>
											</Grid>
										</Grid>
									</Grid>
								)}
								<Grid item xs={12}>
									<UnidadesButtonContainer>
										<UnidadesButton to={'/unidades/'} target='_blank'>
											Ver todas as unidades
										</UnidadesButton>
									</UnidadesButtonContainer>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</S.ExamWrapper>
			</Container>
		</Layout>
	)
}

export default ExameDetalhe
